import React, { useState, useContext } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
// import { AuthServices } from "../../services/AuthService";
import { AuthContext } from "../../Context/AuthContext";
import { Link, useHistory } from "react-router-dom";
import { ApiService } from "../../services/ApiService";
import { useAlert } from "react-alert";

export const First_Login = () => {
  const { login, logout } = useContext(AuthContext);
  const alert = useAlert();
  const history = useHistory();
  const [loader, setLoader] = useState(false);
  // const params = useParams();
  // const [token, settoken] = React.useState(null);

  // React.useEffect(() => {
  //   console.log("RUUNNN");
  //   // localStorage.removeItem("token");
  //   // logout();
  // }, []);
  const load = <span className="fa fa-spin fa-spinner"></span>;
  return (
    <React.Fragment>
      <div className="login-reg-panel">
        <div className="login-white-panel">
          <div className="login-show">
            <center>
              <div className="logo-img">
                <a href="/">
                  <img
                    src="/img/Needle_logo.png"
                    width="191px"
                    alt="needlelogo"
                    height="42px"
                  />
                </a>
                <br></br>
                <small></small>
              </div>
            </center>
            <Formik
              initialValues={{ password: "", confirm_password: "" }}
              validate={(values) => {
                const errors = {};
                if (!values.password) {
                  errors.password = "Required";
                }
                // else if (values.password.length >= 6) {
                //   errors.password = "Password must be atleast 6";
                // }
                return errors;
              }}
              onSubmit={async (values, { setSubmitting }) => {
                // values.token = token;
                console.log(values);
                if (values.password !== values.confirm_password) {
                  return alert.error(
                    "The confirm password and password must match"
                  );
                }
                setLoader(true);
                try {
                  const response = await ApiService.post(
                    "users/first-time-login",
                    values
                  );
                  if (response.data.success === true) {
                    history.push("/login");
                    alert.success("Password reset successully");
                    setLoader(false);
                  } else if (response.data.success === false) {
                    setLoader(false);
                    console.log("eror", response);
                  }
                } catch (error) {
                  localStorage.removeItem("token");
                  // setLoader(false);
                  // alert.error(error.response.data.message);
                  alert.error("Something went wrong, please contact admin");
                  setLoader(false);
                }
              }}
            >
              {({ isSubmitting }) => (
                <Form>
                  <div className="form-group mt-5">
                    <Field
                      type="password"
                      name="password"
                      className="form-control mt-5"
                      placeholder="Password"
                      required
                    />

                    <ErrorMessage name="password" component="div" />
                  </div>

                  <div className="form-group mt-5">
                    <Field
                      type="password"
                      name="confirm_password"
                      className="form-control mt-5"
                      placeholder="Confirm Password"
                      required
                    />

                    <ErrorMessage name="confirm_password" component="div" />
                  </div>

                  <div className="text-center">
                    <Link to="/" className="text-dark">
                      Already have an account? Login
                    </Link>
                  </div>
                  <span className="clearfix"></span>

                  <div className="text-center mt-5">
                    <button
                      type="submit"
                      // disabled={isSubmitting}
                      className="btn btn-block nt-button-color-default btn-sm"
                    >
                      {loader ? load : "Login"}
                    </button>
                  </div>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/container/auth/first_login.js